import EventsBucket from './EventsBucket';

export default EventsBucket;
